import { Pinia, Store } from 'pinia-class-component';
import {
    GroupMaintenanceExtensionUiClient,
    GroupMaintenanceExtension,
} from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
    id: 'GroupMaintenanceExtensionStore',
    name: 'GroupMaintenanceExtensionStore',
})
export default class GroupMaintenanceExtensionStore extends Pinia {
    private readonly api = initClient(GroupMaintenanceExtensionUiClient);

    //data
    private _loadingPromise: Promise<GroupMaintenanceExtension[]> | null = null;
    private _groupMaintenanceExtensions: GroupMaintenanceExtension[] = [];

    //getter
    get loading(): boolean {
        return this._loadingPromise !== null;
    }

    get groupMaintenanceExtensions(): GroupMaintenanceExtension[] {
        return this._groupMaintenanceExtensions;
    }

    get groupMaintenanceExtensionsById(): Map<string, GroupMaintenanceExtension> {
        return new Map(this._groupMaintenanceExtensions.map(e => [e.id, e]));
    }

    //actions
    clear(): void {
        this._groupMaintenanceExtensions.splice(0);
    }

    setGroupMaintenanceExtensions(groupMaintenanceExtensions: GroupMaintenanceExtension[]): void {
        this._groupMaintenanceExtensions.splice(0);
        this._groupMaintenanceExtensions.push(...groupMaintenanceExtensions);
    }

    rememberGroupMaintenanceExtension(groupMaintenanceExtension: GroupMaintenanceExtension): void {
        const index = this._groupMaintenanceExtensions.findIndex(e => e.id === groupMaintenanceExtension.id);
        if (index >= 0) {
            this._groupMaintenanceExtensions.splice(index, 1, groupMaintenanceExtension);
        } else {
            this._groupMaintenanceExtensions.push(groupMaintenanceExtension);
        }
    }

    forgetGroupMaintenanceExtension(groupMaintenanceExtension: GroupMaintenanceExtension): void {
        const index = this._groupMaintenanceExtensions.findIndex(e => e.id === groupMaintenanceExtension.id);
        if (index >= 0) {
            this._groupMaintenanceExtensions.splice(index, 1);
        }
    }

    async reload(force: boolean = false): Promise<void> {
        if (this._loadingPromise) {
            await this._loadingPromise;
            if (!force) {// when force is true, wait for the current operation to complete, then reload
                return;
            }
        }

        try {
            this._loadingPromise = this.api.list();
            const groupMaintenanceExtensions = await this._loadingPromise;
            this.setGroupMaintenanceExtensions(groupMaintenanceExtensions);
        } catch (err) {
            this.clear();
        } finally {
            this._loadingPromise = null;
        }
    }

    async loadIfAbsent(): Promise<void> {
        if (this._groupMaintenanceExtensions.length > 0) {
            return;
        }
        return await this.reload();
    }
}